var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main-layout',[_c('div',{staticClass:"home-container"},[_c('content',{staticClass:"container full d-block pb-5"},[_c('HomeTitle'),_c('div',{staticClass:"row"},[_c('HomeCards'),_c('HomeMain')],1)],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }